import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/User';
import { firstValueFrom } from 'rxjs';

import { Router } from '@angular/router';
import { OfferBannerComponent } from '../offer-banner/offer-banner.component';
import { TranslateModule } from '@ngx-translate/core';
import { PremiumOfferService } from '../../services/premium-offer.service';

@Component({
  selector: 'app-home-teacher-parent',
  standalone: true,
  imports: [OfferBannerComponent, TranslateModule],
  templateUrl: './home-teacher-parent.component.html',
  styleUrl: './home-teacher-parent.component.scss',
})
export class HomeTeacherParentComponent {
  user?: User;
  shouldDisplayPremiumOffer: boolean = false;
  isGarUser: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private premiumOfferService: PremiumOfferService,
  ) {}

  async ngOnInit() {
    const user = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());

    this.user = user;
    this.isGarUser = Boolean(user.gar_ido);
    this.shouldDisplayPremiumOffer = this.premiumOfferService.canSeePremiumOffers(user, { includeTeachers: true });
  }

  navigateToChildHome() {
    this.router.navigate(['homec']);
  }

  navigateToParcoursTP() {
    this.router.navigate(['parcourstp']);
  }

  navigateToHelp() {
    this.router.navigate(['helptp']);
  }

  navigateToFollowUp() {
    if (this.user?.is_parent) {
      this.router.navigate(['follow_up_parent']);
    } else {
      this.router.navigate(['follow_up']);
    }
  }

  navigateToTeachingSheets() {
    this.router.navigate(['teaching_sheets']);
  }
}
